import "./workspace.e021bdc9.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec702"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec702"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("bgeJJ");
parcelRequire("l2CVb");
parcelRequire("fvzOd");
// Lightbox modal logic
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('photo-modal');
    const modalImg = document.getElementById('photo-modal-img');
    const closeBtn = document.querySelector('.photo-modal-close');
    const blur = document.querySelector('.photo-modal-blur');
    const timelineImages = document.querySelectorAll('.timeline-item img');
    timelineImages.forEach((img)=>{
        img.style.cursor = 'pointer';
        img.addEventListener('click', function() {
            modal.classList.add('active');
            modalImg.src = this.src;
            modalImg.alt = this.alt;
        });
    });
    function closeModal() {
        modal.classList.remove('active');
        modalImg.removeAttribute('src');
        modalImg.alt = '';
    }
    closeBtn.addEventListener('click', closeModal);
    blur.addEventListener('click', closeModal);
    // Close with ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });
});


//# sourceMappingURL=bio.be7711d8.js.map
